import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import About from "@/components/home/About";
import Topics from "@/components/home/Topics";
import WorkFromHome from "@/components/home/WorkFromHome";
import Manifesto from "@/components/home/Manifesto";
import CTASection from "@/components/home/CTASection";

export default function HomePage() {
  return (
    <>
      <Seo
        title="Tech Siksha — Learn Technology. Build Skills. Stay Ahead."
        description="Tech Siksha shares practical content on AI tools, website development, mobile apps, productivity, PC tips, automation and modern technology."
      />
      <Hero />
      <About />
      <Topics />
      <WorkFromHome />
      <Manifesto />
      <CTASection />
    </>
  );
}
